import player from './player';
import deck from './deck';

export default [
  ...player,
  ...deck,
];
